var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[(!_vm.$cookies.get('HomePop') && _vm.$store.state.homePop.ImgPath)?_c('Banner'):_vm._e(),_c('HomeSection0'),_c('YoutubeVideo'),_c('HomeSection2'),_c('HomeSection3'),_c('HomeSection4')],1)}
var staticRenderFns = []

export { render, staticRenderFns }